
import { Button, Modal } from 'antd';
import React, { SetStateAction, useEffect, useState } from 'react';
import IdleTimer from 'react-idle-timer';

/**
 * Count down in seconds
 */
const COUNT_DOWN = 30;

type Props = {
  isVisible: boolean,
  setIsVisible: React.Dispatch<SetStateAction<boolean>>,
  idleTimerRef: React.MutableRefObject<IdleTimer>,
  signOut: (forced?: boolean) => void
};

const IdleTimeOutModal: React.FC<Props> = ({
  isVisible,
  setIsVisible,
  idleTimerRef,
  signOut
}) => {
    const [seconds, setSeconds] = useState<number>();
    let timeout: NodeJS.Timeout;
    let timer: NodeJS.Timeout;

    useEffect(() => {
      if (isVisible) {
          setSeconds(COUNT_DOWN);
          startCountdown(); 
      }


      return () => {
        clear();
      };
    }, [isVisible])

    /**
     * Start time out modal count down 
     */
    const startCountdown = () => {
      let secondsToGo = COUNT_DOWN;

      timer = setInterval(() => {
        secondsToGo -= 1;
        setSeconds(secondsToGo);
      }, 1000);

      timeout = setTimeout(() => {
          clearInterval(timer);
          setIsVisible(false);
          signOut();  
      }, COUNT_DOWN * 1000);
    }

    /**
     * Stay signed in
     */
    const handleStay = () => {
        clear();
        idleTimerRef.current.reset();
        setIsVisible(false);
    }

    /**
     * Force sign out now
     */
    const handleSignOut = () => {
      clear();
      signOut(true);
    }

    /**
     * Clear timeout and time interval
     */
    const clear = () => {
      clearTimeout(timeout);
      clearInterval(timer);
    }

    return (
      <Modal
          centered
          maskClosable={false}
          title="Session Expiration Warning"
          visible={isVisible}
          footer={[
              <Button id="staySignInButton" type="primary" key="stay" onClick={handleStay}>
                  Stay Signed In
              </Button>,
              <Button id="signOutNowButton" key="signout" onClick={handleSignOut}>
                  Sign Out Now
              </Button>
          ]}
          closable={false}
      >
          <>
              <p>Due to inactivity, your session is about to expire.</p>
              <p>Time remaining: {seconds} seconds</p>
          </>
      </Modal>
    )
}

export default IdleTimeOutModal;